// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Packages_pageHeader__2Bq7T"};